<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="pi"></a>THE SORCERER’S APPRENTICE</p>
<p class="ht-orna"><img alt="Zipes" src="images/ornament1.png"/></p>
<p class="pbreak"></p>
<p class="image"><a id="pii"></a><img alt="Zipes" src="images/page_ii.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// half_title.vue?ce377ed8